export const DATA_GRID_STATE_KEY = 'nutrisense:shipping:amazonOrders:dataGrid:state'
